module.exports = __webpack_public_path__ + "files/c89aa43e0646a61fcee6518540c6ebda.png";